/* eslint-disable no-use-before-define */

import React from 'react'
import { getId } from '../twd'

export default ({field, form, label, value, className, style, ...props}) => {
    const id = getId()

    return (
    <div className={"radio " + (className || '')} style={style}>
    <input type="radio"
        id={id}
        name={field.name}
        value={value}
        checked={field.value===value}
        {...props}
        onChange={field.onChange}
        onBlur={field.onBlur}
        />
    <label htmlFor={id}>{label}</label>
    </div>
    )
}


// WEBPACK FOOTER //
// ./src/twd/fields/radio.js